import ContactForm from "@/components/ContactForm";
import Head from "next/head";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import webBanner from "../public/images/page_banner/igbc_banner.jpg";
import mobBanner from "../public/images/page_banner/igbc_mob.jpg";
import Image from "next/image";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Igbc = ({ data }) => {
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd water_mark">
        <Container>
          <div className="inner_text text-center">
            <Row className="justify-content-center">
              <Col md={12}>
                <div
                  className="head_wrap"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1000"
                >
                  <div className="center-title">
                    <h2 className="section-title">
                      Indian Green Building Council
                    </h2>
                  </div>
                </div>
                <p
                  className="mb-0"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  The Indian Green Building Council (IGBC), part of the
                  Confederation of Indian Industry (CII) was formed in the year
                  2001. The vision of the council is, "To enable a sustainable
                  built environment for all and facilitate India to be one of
                  the global leaders in the sustainable built environment by
                  2025".
                </p>
                <div className="mt-30">
                  <div
                    className="head_wrap"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1000"
                  >
                    <div className="center-title">
                      <h2 className="section-title">
                        IGBC Green Affordable Housing
                      </h2>
                    </div>
                  </div>
                  <p
                    className="mb-0"
                    data-aos="fade-up"
                    data-aos-delay="400"
                    data-aos-duration="1000"
                  >
                    While rapid urbanisation, growing cities provide various
                    opportunities, but also there are many drawbacks in terms of
                    proliferation of slums, high prices of land and building
                    materials which render houses unaffordable for the lower
                    income group of people. Therefore, the need for adequate
                    housing for the low-income groups will substantially
                    increase. Most importantly, while we create housing for
                    these sections of the society, they need to be green too.
                  </p>
                </div>
              </Col>
            </Row>
            <div className="sec-padd-top  benfit-wrap">
              <div className="head_wrap">
                <div className="center-title">
                  <h2 className="section-title">Benefits</h2>
                </div>
              </div>
              <div className="mt-2 mt-md-4">
                <Row className="justify-content-center">
                  <Col md={2}>
                    <div
                      className="icon_box"
                      data-aos="fade-up"
                      data-aos-delay="100"
                      data-aos-duration="1000"
                    >
                      <div className="img-wrap image-container">
                        <Image
                          fill
                          src="/images/icons/energy.png"
                          alt="interior"
                          className="image"
                        />
                      </div>
                      <p className="my-3">
                        Reduction in energy and water consumption
                      </p>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div
                      className="icon_box"
                      data-aos="fade-up"
                      data-aos-delay="200"
                      data-aos-duration="1000"
                    >
                      <div className="img-wrap image-container">
                        <Image
                          fill
                          src="/images/icons/health.png"
                          alt="interior"
                          className="image"
                        />
                      </div>
                      <p className="my-3">Improved health & hygiene</p>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div
                      className="icon_box"
                      data-aos="fade-up"
                      data-aos-delay="300"
                      data-aos-duration="1000"
                    >
                      <div className="img-wrap image-container">
                        <Image
                          fill
                          src="/images/icons/sanitation.png"
                          alt="interior"
                          className="image"
                        />
                      </div>
                      <p className="my-3">Better sanitation</p>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div
                      className="icon_box"
                      data-aos="fade-up"
                      data-aos-delay="400"
                      data-aos-duration="1000"
                    >
                      <div className="img-wrap image-container">
                        <Image
                          fill
                          src="/images/icons/sanitation.png"
                          alt="interior"
                          className="image"
                        />
                      </div>
                      <p className="my-3">
                        Better ventilation and light in the dwellings
                      </p>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div
                      className="icon_box"
                      data-aos="fade-up"
                      data-aos-delay="500"
                      data-aos-duration="1000"
                    >
                      <div className="img-wrap image-container">
                        <Image
                          fill
                          src="/images/icons/pollution.png"
                          alt="interior"
                          className="image"
                        />
                      </div>
                      <p className="my-3">
                        Fuel savings in transit of people to workplaces and
                        associated pollution
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Igbc;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/igbc?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
